import emailjs from '@emailjs/browser';

// EmailJS configuration
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_jurxo5j';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_bu381bn';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'ZulnQlQ3XYIn4pArE';


interface QuoteFormData {
  recoveryType: string;
  collectionPostcode: string;
  deliveryPostcode: string;
  phoneNumber: string;
  regNumber: string;
  make: string;
  model: string;
  date: string;
}

export const sendQuoteEmail = async (formData: QuoteFormData): Promise<void> => {
  try {
    console.log('📧 Starting email send process');
    console.log('📝 Form data received:', formData);
    console.log('🔍 process.env check:', {
      service: process.env.REACT_APP_EMAILJS_SERVICE_ID,
      template: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      key: process.env.REACT_APP_EMAILJS_PUBLIC_KEY ? 'Present' : 'Missing'
    });
    console.log('🔍 Actually using Service ID:', EMAILJS_SERVICE_ID);

    // Prepare template parameters for EmailJS
    const templateParams = {
      to_email: 'daniyalahmed1398@gmail.com',           // Replace with your email
      recovery_type: formData.recoveryType,
      phone_number: formData.phoneNumber,
      collection_postcode: formData.collectionPostcode,
      delivery_postcode: formData.deliveryPostcode,
      reg_number: formData.regNumber,
      make: formData.make,
      model: formData.model,
      requested_date: formData.date,
      submitted_at: new Date().toLocaleString('en-GB', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    };

    console.log('📧 Sending email with EmailJS...');

    // Send email using EmailJS
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams,
      EMAILJS_PUBLIC_KEY
    );

    if (response.status === 200) {
      console.log('✅ Email sent successfully!');
      console.log('📧 EmailJS response:', response);
    } else {
      throw new Error(`EmailJS responded with status: ${response.status}`);
    }

  } catch (error) {
    console.error('❌ Error sending email:', error);
    if (error instanceof Error) {

      console.error('❌ Error details:', error.message);
    }
    throw error;
  }
};

// Initialize EmailJS (call this once when your app starts)
export const initEmailJS = (): void => {
  try {
    emailjs.init(EMAILJS_PUBLIC_KEY);
    console.log('✅ EmailJS initialized successfully');
  } catch (error) {
    console.error('❌ Error initializing EmailJS:', error);
  }
}; 